import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";


export default function Portfolio() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div>
      <Helmet>
      <title>Our Portfolio - Technic Mentors</title>
      <link rel="canonical" href="https://technicmentors.com/portfolio/" />
    </Helmet>
      <div className="allHeaderBg">
        <div className="allHeader-overlay d-flex align-items-center justify-content-center">
          <div>
            <h1 className="head text-center text-white animate__animated animate__zoomIn allHeaderP">
              Our Exclusive Portfolio
            </h1>
          </div>
        </div>
      </div>

      {/* <section id="services-section">
        <div className="container">
          <div
            className="row"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
          >
            <div className="col-lg-6">
              <div
                className="section-title text-start"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                <h2> Our past Work Speaks Of Our Quality</h2>
                <h3>
                  Explore Our <span>Portfolio</span>
                </h3>
              </div>
              <p style={{ textAlign: "justify" }}>
                Technic Mentors is more than a software company; we're your
                technology partners, bringing innovative ideas to life. Our
                portfolio showcases a spectrum of software services, from web
                and mobile app development to custom solutions, AI, blockchain,
                and cloud technologies. We're driven by your success and
                collaborate closely to create digital solutions that surpass
                expectations.
              </p>
              <p>
                Our exclusive portfolio represents our passion for creativity
                and client success. Projects like the groundbreaking mobile app
                in different industries and the game-changing e-commerce
                platform for several local and international companies stand as
                testaments to our dedication to excellence. With a commitment to
                quality, security, and peak performance, we aim to set new
                industry standards. Reach out to us, and together, we can turn
                your vision into a remarkable digital reality.
              </p>
            </div>

            <div className="col-lg-6 d-flex align-items-center justify-content-center">
              <img
                src="assets/img/portfolio-img.png"
                className="img-fluid"
                alt="mentors-portfolio"
              />
            </div>
          </div>
        </div>
      </section> */}

      {/* <section>
        <div className="container">
          <div
            className="row flex-md-row-reverse"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
          >
            <div className="col-lg-6 order-md-1">
              <div
                className="section-title text-start"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
              >
                <h2>Journey of Excellence</h2>
                <h3>
                  Exploring Our <span> Diverse Portfolio</span>
                </h3>
              </div>
              <p style={{ textAlign: "justify" }}>
                Step into our Portfolio, a showcase that transcends boundaries
                and defines our journey through impactful projects. As you
                navigate, each project unfolds its unique narrative, a testament
                to the diverse tapestry of work we've undertaken. From the sleek
                sophistication of corporate websites to the intricate
                functionality of custom software, our portfolio mirrors the
                breadth and depth of our capabilities.
              </p>
              <p>
                Dive into a world where innovation knows no bounds. Our projects
                span industries, from cutting-edge e-commerce solutions that
                redefine online experiences to intuitive mobile applications
                that breathe life into ideas. Whether it's the seamless design
                of digital storefronts, the development of bespoke software
                solutions, or the integration of pioneering technologies, our
                portfolio speaks volumes about our commitment to turning visions
                into reality. Explore the mosaic of our past endeavors, each a
                canvas painted with the passion and precision that defines our
                craft.
              </p>
              <p>
                Each project is a collaborative journey, a fusion of our
                expertise and client aspirations, resulting in solutions that
                not only meet expectations but exceed them. Welcome to a gallery
                of success stories, where your project could be the next chapter
                in our narrative of innovation and achievement.
              </p>
            </div>
            <div className="col-lg-6 order-md-2 d-flex align-items-center justify-content-center">
              <img
                src="assets/img/portfolio.webp"
                className="img-fluid"
                alt="our-diverse-portfolio"
              />
            </div>
          </div>
        </div>
      </section> */}

      {/* <section>
        <div
          className="container"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
        >
          <div className="row">
            <div className="col-md-4 port-column mt-4">
              <div className="portfolio-cards">
                <div className="card-body">
                  <div className="fa-2x ">
                    <i
                      className="fa-regular fa-lightbulb mb-4"
                      style={{ color: "#106ec6" }}
                    ></i>
                    <p style={{ color: "#106ec6" }}>
                      <strong>Innovative Solutions</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 port-column mt-4">
              <div className="portfolio-cards">
                <div className="card-body">
                  <div className="fa-2x">
                    <i
                      className="fa-regular fa-handshake mb-4"
                      style={{ color: "#106ec6" }}
                    ></i>
                    <p style={{ color: "#106ec6" }}>
                      <strong>Collaborative Partnerships</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 port-column mt-4">
              <div className="portfolio-cards ">
                <div className="card-body">
                  <div className="fa-2x">
                    <i
                      className="fa-solid fa-fingerprint mb-4"
                      style={{ color: "#106ec6" }}
                    ></i>
                    <p style={{ color: "#106ec6" }}>
                      <strong>Quality And Security</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <section
        className="clients-portfolio-section "
        style={{ backgroundColor: "#f1f3fe" }}
      >
        <div className="container mt-4">
          <div
            className="section-title mb-3 text-center"
            style={{ paddingBottom: "0" }}
          >
            <h2> Web Development Projects </h2>
            <h3>
              Our Portfolio Of <span>Web Development Projects</span>{" "}
            </h3>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-10">
              <p className="mb-4 text-center">
                Our Portfolio of Web Development Projects showcases the diverse
                range of websites we've created for clients across various
                industries. From sleek corporate websites to dynamic ecommerce
                platforms, each project reflects our commitment to quality,
                innovation, and user experience. Our portfolio highlights custom
                designs tailored to each client's needs, ensuring functionality
                and visual appeal. Whether it's educational websites that
                promote learning, service-oriented sites that drive business, or
                creative portfolio pages that showcase talent, our web
                development projects demonstrate our versatility and expertise
                in delivering top-tier digital solutions. Explore our portfolio
                to see how we bring visions to life.
              </p>
            </div>
          </div>
          <div className="container">
           

            <div className="row ">
              

            <div className="col-md-6 col-lg-4 ">
                <a
                  href="https://legalexglobal.co.uk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\legalexglobal-portfolio-technicmentors.webp"
                    className="img-fluid portfolio-images"
                    alt="legalex-global-site by Technic Mentors"
                  />
                </a>
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    LEGALEX GLOBAL
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-4  ">
                <a href="https://k2land.pk/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\k2-portfolio-technicmentors.webp"
                    className="img-fluid portfolio-images"
                    alt="k2-land-site by Technic Mentors"
                  />
                </a>
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    <a
                      href="https://k2land.pk/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      k2 LAND
                    </a>
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 mb-3  ">
                <a
                  href="https://bcdserve.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\bcd-serve-technic-mentors.webp"
                    className="img-fluid portfolio-images"
                    alt="bcd-services-site by Technic Mentors"
                  />
                </a>
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    BCD SERVICES
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-4  ">
                <a
                  href="https://firstclicksolutions.co.uk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\first-click-portfolio-technicmentors.webp"
                    className="img-fluid portfolio-images"
                    alt="first-click-solutions-site by Technic Mentors"
                  />
                </a>
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    FIRST CLICK SOLUTIONS
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-4 ">
                <a
                  href="https://educatia.pk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\educatia-studyabroad.png"
                    className="img-fluid portfolio-images"
                    alt="educatia-site by Technic Mentors"
                  />
                </a>
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    Educatia
                  </p>
                </div>
              </div>

              

              <div className="col-md-6 col-lg-4 ">
                <a href="https://getwell.pk/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\getwell-website-technicmentors.webp"
                    className="img-fluid portfolio-images"
                    alt="get-well-site by Technic Mentors"
                  />
                </a>
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    <a
                      href="https://getwell.pk/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      GET WELL
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              

              <div className="col-md-6 col-lg-4 ">
                <a
                  href="https://capobrain.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\capobrain-school-management.png"
                    className="img-fluid portfolio-images"
                    alt="capobrain-site by Technic Mentors"
                  />
                </a>
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    CAPOBRAIN
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-3 ">
                <a
                  href="https://pees.pk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src="assets\img\portfolio\pees-technicmentors.png"
                    className="img-fluid portfolio-images"
                    alt="pees-site by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >PHOTONICS ENGINEERING</h2>
                </div>
              </div>

              <div className="col-md-4 mb-3 ">
                <a href="https://review.imlpk.com/" target="_blank" rel="noreferrer">
                  <img
                    src="assets\img\portfolio\intermarket-technicmentors.png"
                    className="img-fluid portfolio-images"
                    alt="intermarket-site by Technic Mentors"
                  />
                </a>
                <div className="section-title text-center">
                  <h2 className="mt-2" style={{ backgroundColor: "white" }} >INTER MARKET</h2>
                </div>
              </div>

              
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <Link to="/website-portfolio">
         <button className="primaryBtn px-4 py-2 mb-3">
  Explore All &rarr;
</button>

          </Link>
        </div>
      </section>
      {/* wen portfolio */}

      <section
        className="clients-portfolio-section"
        style={{ backgroundColor: "#f1f3fe" }}
      >
        <div className="container">
          <div className="section-title mb-3 text-center">
            <h2> Web Software Projects </h2>
            <h3>
              Our Portfolio Of <span>Web Apps/Software</span>{" "}
            </h3>
          </div>
          <div className="container">
            <div className="row">
                 <div className="col-md-6 col-lg-3 ">
                <img
                  src="assets\img\software portfolio\law-system-technicmentors.png"
                  className="img-fluid portfolio-images"
                  alt="law-firm-management-system by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                 Law Firm Management System
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3  ">
                <img
                  src="assets\img\portfolio\pos-technicmentors.png"
                  className="img-fluid portfolio-images"
                  alt="web-pos-software by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                  	POS cloud Based - Standard Version
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3 ">
                <img
                  src="assets\img\portfolio\resturent-management-system.png"
                  className="img-fluid portfolio-images"
                  alt="resturant-management-system-software by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    Restaurant Management system
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3  ">
                <img
                  src="assets\img\software portfolio\tailoring-system-software.png"
                  className="img-fluid portfolio-images"
                  alt="tailoring-software-software by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                   Production Management System
                  </p>
                </div>
              </div>
            </div>

            <div className="row ">
              <div className="col-md-6 col-lg-3 ">
                <img
                  src="assets\img\software portfolio\capobiz-technicmentors.png"
                  className="img-fluid portfolio-images"
                  alt="ERP-software by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    CapoBiz - Mini ERP
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3 ">
                <img
                  src="assets\img\software portfolio\consultancy-management-system.png"
                  className="img-fluid portfolio-images"
                  alt="consultancy-management-system by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    CONSULTANCY Management System
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3  ">
                <img
                  src="assets\img\software portfolio\capobrain-school-management.png"
                  className="img-fluid portfolio-images"
                  alt="trading-software by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    Capobrain- Schoool Management Software
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3 ">
                <img
                  src="assets\img\software portfolio\getwell-medicine.png"
                  className="img-fluid portfolio-images"
                  alt="multivendor-medicines-marketplace-software by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                  	Multivendor Medicines Marketplace

                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-3 mb-3">
                <img
                  src="assets\img\software portfolio\wheel-bidz-cars-technicmentors.png"
                  className="img-fluid portfolio-images"
                  alt="billing-software by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                   Vehicles Auction Marketplace
                  </p>
                </div>
              </div>
                <div className="col-md-6 col-lg-3 ">
                <img
                  src="assets\img\software portfolio\fertilizer-management-system.png"
                  className="img-fluid portfolio-images"
                  alt="fertilizer-management-system by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                   Fertilizer Industry Management System
                  </p>
                </div>
              </div>
               <div className="col-md-6 col-lg-3 ">
                <img
                  src="assets\img\software portfolio\tailoring-management-software.png"
                  className="img-fluid portfolio-images"
                  alt="tailoring-management-system by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                 	Tailoring Management System
                  </p>
                </div>
              </div>
             <div className="col-md-6 col-lg-3 ">
                <img
                  src="assets\img\software portfolio\desktop-pos-technicmentors.webp"
                  className="img-fluid portfolio-images"
                  alt="desktop-pos-software by Technic Mentors"
                />
                <div className="portfolio-title text-center">
                  <p className="mt-2" style={{ backgroundColor: "white" }}>
                    Desktop pos
                  </p>
                </div>
              </div>
            </div>
           
          </div>
          
        </div>
         <div className="d-flex justify-content-center">
          <Link to="/software-portfolio">
                <button className="primaryBtn px-4 py-2 mb-3">
  Explore All &rarr;
</button>
          </Link>
        </div>
      </section>
      {/* wen portfolio */}
      {/* Mobile apps portfolio */}
<section
  className="clients-portfolio-section mt-4"
  style={{ backgroundColor: "#f1f3fe" }}
>
  <div className="container mt-4">
    <div className="section-title mb-5 text-center">
      <h2>Mobile Apps Projects</h2>
      <h3>
        Our Portfolio Of <span>Android & iOS Applications</span>
      </h3>
    </div>

    <div className="container">
      {/* Row 1 */}
      <div className="row mt-4">
        <div className="col-6 col-md-3 mb-4">
          <Link to="/app/happy-stack-tower" style={{ textDecoration: 'none' }}>
            <div className="portfolio-item">
              <img
                src="assets/img/app portfolio/happy-stack-tower-home-screen.webp"
                className="portfolio-images"
                alt="Happy Stack tower Game by Technic Mentors"
              />
            </div>
          </Link>
          <div className="section-title text-center">
            <h2 className="mt-2" style={{ backgroundColor: "white" }}>
              Happy Stack Tower
            </h2>
          </div>
        </div>

        <div className="col-6 col-md-3 mb-4">
          <Link to="/app/wallnex" style={{ textDecoration: 'none' }}>
            <div className="portfolio-item">
              <img
                src="assets/img/app portfolio/wallnex-hd-wallpapers-home-screen.webp"
                className="portfolio-images"
                alt="WallNex - HD Wallpapers App by Technic Mentors"
              />
            </div>
          </Link>
          <div className="section-title text-center">
            <h2 className="mt-2" style={{ backgroundColor: "white" }}>
              WallNex - HD Wallpapers
            </h2>
          </div>
        </div>

        <div className="col-6 col-md-3 mb-4">
          <Link to="/app/scan2pdf" style={{ textDecoration: 'none' }}>
            <div className="portfolio-item">
              <img
                src="assets/img/app portfolio/scan2pdf-pdf-export-options-technicmentors.webp"
                className="portfolio-images"
                alt="Scan2PDF - Document Scanner by Technic Mentors"
              />
            </div>
          </Link>
          <div className="section-title text-center">
            <h2 className="mt-2" style={{ backgroundColor: "white" }}>
              Scan2PDF - Document Scanner 
            </h2>
          </div>
        </div>

        <div className="col-6 col-md-3 mb-4">
          <Link to="/app/convert-units" style={{ textDecoration: 'none' }}>
            <div className="portfolio-item">
              <img
                src="assets/img/app portfolio/convert-units-home-screen-technicmentors.webp"
                className="portfolio-images"
                alt="Convert Units App by Technic Mentors"
              />
            </div>
          </Link>
          <div className="section-title text-center">
            <h2 className="mt-2" style={{ backgroundColor: "white" }}>
              Convert Units
            </h2>
          </div>
        </div>
      </div>

      {/* Row 2 */}
      <div className="row mt-4">
        <div className="col-6 col-md-3 mb-4">
          <Link to="/app/tafheem-audio" style={{ textDecoration: 'none' }}>
            <div className="portfolio-item">
              <img
                src="assets/img/app portfolio/tafheem-audio-player-screen-technicmentors.webp"
                className="portfolio-images"
                alt="Tafheem Audio Quran App by Technic Mentors"
              />
            </div>
          </Link>
          <div className="section-title text-center">
            <h2 className="mt-2" style={{ backgroundColor: "white" }}>
              Tafheem Audio
            </h2>
          </div>
        </div>

        <div className="col-6 col-md-3 mb-4">
          <Link to="/app/maududi-books" style={{ textDecoration: 'none' }}>
            <div className="portfolio-item">
              <img
                src="assets/img/app portfolio/maududi-books-book-list-technicmentors.png"
                className="portfolio-images"
                alt="Maududi Books Collection App by Technic Mentors"
              />
            </div>
          </Link>
          <div className="section-title text-center">
            <h2 className="mt-2" style={{ backgroundColor: "white" }}>
              Maududi Books Collection
            </h2>
          </div>
        </div>

      <div className="col-6 col-md-3 mb-4">
  <Link to="/app/tourist-guide" style={{ textDecoration: 'none' }}>
    <div className="portfolio-item">
      <img
        src="assets/img/app portfolio/tourist-guide-home-screen-technicmentors.jpg"
        className="portfolio-images"
        alt="Tourist Guide"
      />
    </div>
  </Link>
  <div className="section-title text-center">
    <h2 className="mt-2" style={{ backgroundColor: "white" }}>
      Tourist Guide
    </h2>
  </div>
</div>


      <div className="col-6 col-md-3 mb-4">
  <Link to="/app/warrenty-app" style={{ textDecoration: 'none' }}>
    <div className="portfolio-item">
      <img
        src="assets/img/app portfolio/warranty-app-add-product-technicmentors.jpg"
        className="portfolio-images"
        alt="Warranty App by Technic Mentors"
      />
    </div>
  </Link>
  <div className="section-title text-center">
    <h2 className="mt-2" style={{ backgroundColor: "white" }}>
      Warranty App
    </h2>
  </div>
</div>

      </div>
    </div>
  </div>

  <div className="d-flex justify-content-center">
    <Link to="/app-portfolio">
          <button className="primaryBtn px-4 py-2 mb-1">
  Explore All &rarr;
</button>
    </Link>
  </div>
</section>

    </div>
  );
}


